import React from 'react';

const Stepper = ({ steps, currentStep }) => {
    return (
        <div className="mb-8">
            <div className="flex justify-between items-center">
                {steps.map((step, index) => (
                    <div key={step.number} className="flex-1 relative">
                        <div className={`flex flex-col items-center ${index < steps.length ? 'after:content-[""] after:absolute after:top-5 after:w-full after:h-0.5 after:bg-gray-300 after:z-0' : ''
                            }`}>
                            <div className={`w-10 h-10 rounded-full flex items-center justify-center z-10 ${currentStep >= step.number ? 'bg-brand-600 text-white' : 'bg-gray-300'
                                }`}>
                                {step.number}
                            </div>
                            <span className="text-sm mt-2 text-center text-gray-600">
                                {step.title}
                            </span>
                        </div>
                        {index === steps.length - 1 && (
                            <div className="absolute top-5 left-1/2 w-1/2 h-0.5 bg-gray-300" />
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Stepper;
